export const isFunction = v => typeof v === 'function'
